import React from 'react';
import { useEventEmitter, useNumberFormat } from 'hooks';
import * as Utils from 'utils';

export default function CartOptionsPages({
  options,
  optionsPagesTotal,
  projectTypeActive
}) {

  let pagesTotalText;
  if (projectTypeActive === 'email') {
    pagesTotalText = 'Templates total';
  } else if (projectTypeActive === 'banners') {
    pagesTotalText = 'Banners total';
  } else {
    pagesTotalText = 'Pages total';
  }

  const {discount, totalPricePages} = optionsPagesTotal;
  const {format} = useNumberFormat();
  const events = useEventEmitter();

  const onHandleIncrease = (optionId) => {
    events.emit('Increase', optionId);
  };

  const onHandleDecrease = (optionId) => {
    events.emit('Decrease', optionId);
  };

  return (
    <>
      {options.length > 0 &&
        <div className="app-cart-options">
          <div className="app-cart-option-list">
            {options.map((option) => {
              const {
                id,
                priceValueStart,
                priceValueStartText,
                priceLabelStart,
                totalQuantity,
                total
              } = option;

              return (
                <div className="app-cart-option-item" key={id}>
                  {priceValueStart && priceValueStartText ? (
                    <div>
                      <div className="app-cart-line">
                        <div className="app-cart-line-left">
                          <span className="app-cart-text-parameter">{priceLabelStart}</span>
                        </div>
                        <div className="app-cart-line-right">
                          <span className="app-cart-text-value">{Utils.replacer(option, 'priceValueStartText')}</span>
                        </div>
                      </div>
                      <div className="app-cart-line">
                        {totalQuantity > 0 && (
                          <>
                            <div className="app-cart-line-left">
                              <strong className="app-cart-text-sign app-cart-text-sign--minus" onClick={() => onHandleDecrease(id)}></strong>
                              <strong className="app-cart-text-sign app-cart-text-sign--plus" onClick={() => onHandleIncrease(id)}></strong>
                              <span className="app-cart-text-parameter-light">{Utils.replacer(option, 'priceLabel')}</span>
                            </div>
                            <div className="app-cart-line-right">
                              <span className="app-cart-text-value-light">
                                {total === 0 ? (
                                  <>
                                    <span className="app-cart-text-value-light">
                                      {totalQuantity} = </span><span className="app-cart-text-value">$Custom
                                    </span>
                                  </>
                                ) : (
                                  <>
                                    <span className="app-cart-text-value-light">
                                    {totalQuantity} &#215; {Utils.replacer(option, 'priceValueText')} = </span><span className="app-cart-text-value">${total}
                                    </span>
                                  </>
                                )}
                              </span>
                            </div>
                          </>
                        )}
                      </div>
                    </div>
                  ) : (
                    <div className="app-cart-line">
                      <div className="app-cart-line-left">
                        <strong className="app-cart-text-sign app-cart-text-sign--minus" onClick={() => onHandleDecrease(id)}></strong>
                        <strong className="app-cart-text-sign app-cart-text-sign--plus" onClick={() => onHandleIncrease(id)}></strong>
                        <span className="app-cart-text-parameter-light" >{Utils.replacer(option, 'priceLabel')}</span>
                      </div>
                      <div className="app-cart-line-right">
                        {total === 0 ? (
                            <>
                              <span className="app-cart-text-value-light">{totalQuantity} </span>
                              <span className="app-cart-text-value">to be paid later</span>
                            </>
                        ) : (
                            <>
                              <span className="app-cart-text-value-light">{totalQuantity} &#215; {Utils.replacer(option, 'priceValueText')} = </span>
                              <span className="app-cart-text-value">${total}</span>
                            </>
                        )}
                      </div>
                    </div>
                  )}
                </div>
              )
            })}
          </div>
          {/*{discount > 0 && (*/}
          {/*  <div className="app-cart-discount">*/}
          {/*    <div className="app-cart-line">*/}
          {/*      <div className="app-cart-line-left">*/}
          {/*        <span className="app-cart-text-parameter">Discount</span>*/}
          {/*      </div>*/}
          {/*      <div className="app-cart-line-right">*/}
          {/*        <span className="app-cart-text-value">${format(discount)}</span>*/}
          {/*      </div>*/}
          {/*    </div>*/}
          {/*  </div>*/}
          {/*)}*/}
          {totalPricePages > 0 && (
            <div className="app-cart-total">
              <div className="app-cart-line">
                <div className="app-cart-line-left">
                  <span className="app-cart-text-parameter">{pagesTotalText}</span>
                </div>
                <div className="app-cart-line-right">
                  <span className="app-cart-text-value">${format(totalPricePages)}</span>
                </div>
              </div>
            </div>
          )}
        </div>
      }
    </>
  )
}
